// Theme configuration and utilities
export const THEMES = {
  WIMBLEDON: 'easy-english',
  HARD_COURT: 'awesome-aussie',
  LAUNCH: 'launch',
  USUALLY_UNITED: 'usually-united',
  FREAKING_FRENCH: 'freaking-french',
}

export const THEME_CONFIGS = {
  [THEMES.WIMBLEDON]: {
    name: 'Easy English',
    description: 'Classic green & purple',
    colors: {
      '--fl-theme-primary': '#046a3a',
      '--fl-theme-primary-dark': '#034d29',
      '--fl-theme-primary-darker': '#023520',
      '--fl-theme-primary-light': '#058c4d',
      '--fl-theme-primary-lighter': '#0ab366',
      '--fl-theme-primary-lightest': '#e6f4ed',
      '--fl-theme-secondary': '#3d2273',
      '--fl-theme-secondary-dark': '#2d1955',
      '--fl-theme-secondary-light': '#5a3399',
      '--fl-theme-secondary-lightest': '#ede8f5',
      '--fl-theme-tertiary': '#3d2273',
      '--fl-theme-tertiary-dark': '#2d1955',
      '--fl-theme-tertiary-light': '#5a3399',
      '--fl-theme-tertiary-lightest': '#ede8f5',
      '--fl-gradient-blue-mid': '#256e56',
      '--fl-gradient-blue-mid-light': '#2f8566',
      '--fl-gradient-blue-mid-alpha': 'rgba(37, 110, 86, 0.12)',
      '--fl-theme-surface': '#f2f1f5',
      '--fl-theme-surface-dim': '#e5e4e8',
      '--fl-theme-surface-bright': '#fafafa',
      '--fl-theme-outline': '#d1d0d5',
      '--fl-theme-outline-variant': '#e5e4e8',
      '--fl-button-neutral-bg': '#f8f9fa',
      '--fl-button-neutral-bg-hover': '#e9ecef',
      '--fl-button-neutral-bg-active': '#dee2e6',
      '--fl-button-neutral-border': '#dee2e6',
      '--fl-button-neutral-border-hover': '#adb5bd',
      '--fl-button-neutral-text': '#212529',
      '--fl-button-neutral-shadow': 'rgba(0, 0, 0, 0.08)',
      '--fl-button-neutral-shadow-hover': 'rgba(0, 0, 0, 0.12)',
      '--fl-shadow-tertiary-light': 'rgba(61, 34, 115, 0.15)',
      '--fl-shadow-tertiary-medium': 'rgba(61, 34, 115, 0.25)',
      '--fl-shadow-tertiary-heavy': 'rgba(61, 34, 115, 0.35)',
      '--fl-shadow-blue-lighter': 'rgba(4, 106, 58, 0.08)',
      '--fl-shadow-blue-light': 'rgba(4, 106, 58, 0.15)',
      '--fl-shadow-blue-medium': 'rgba(4, 106, 58, 0.2)',
      '--fl-shadow-blue-strong': 'rgba(4, 106, 58, 0.25)',
      '--fl-shadow-blue-heavy': 'rgba(4, 106, 58, 0.3)',
      '--fl-shadow-modal-backdrop': 'rgba(0, 0, 0, 0.6)',
      '--fl-shadow-modal-elevated': 'rgba(0, 0, 0, 0.3)',
      '--fl-shadow-white-translucent': 'rgba(255, 255, 255, 0.2)',
      '--fl-shadow-white-semi': 'rgba(255, 255, 255, 0.3)',
      '--fl-shadow-white-outline': 'rgba(255, 255, 255, 0.8)',
      '--fl-focus-outline-color': '#046a3a',
      '--fl-gradient-primary':
        'linear-gradient(135deg, #046a3a 0%, #034d29 100%)',
      '--fl-gradient-hero':
        'linear-gradient(135deg, #046a3a 0%, #256e56 55%, #3d2273 100%)',
      '--fl-gradient-subtle':
        'linear-gradient(135deg, #e6f4ed 0%, #ede8f5 100%)',
      '--fl-gradient-horizontal':
        'linear-gradient(90deg, #046a3a 0%, #256e56 50%, #3d2273 100%)',
      '--fl-theme-on-primary': '#fff',
      '--fl-theme-on-secondary': '#fff',
      '--fl-theme-on-tertiary': '#fff',
      '--fl-text-quaternary': '#9ca3af',
      '--fl-link-color': '#046a3a',
      '--fl-link-hover': '#034d29',
      '--fl-color-success': '#27ae60',
      '--fl-color-error': '#e74c3c',
      '--fl-color-white': '#ffffff',
      '--fl-color-disabled': '#7f8c8d',
      '--fl-notification-badge': '#FF3B30',
      '--fl-status-bg-tint-start': 'rgba(4, 106, 58, 0.06)',
      '--fl-status-bg-tint-end': 'rgba(3, 77, 41, 0.04)',
      '--fl-status-divider': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-bg': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-fill-start': '#16a34a',
      '--fl-status-progress-fill-end': '#22c55e',
      '--fl-status-notice-text': '#92400e',
      '--fl-analytics-gender-male': '#0088FE',
      '--fl-analytics-gender-female': '#FF69B4',
      '--fl-analytics-gender-neutral': '#77c',
      '--fl-analytics-node-fill': '#0088FE',
      '--fl-analytics-node-text': '#333',
      '--fl-nav-link-bg': 'rgba(255, 255, 255, 0.15)',
      '--fl-nav-link-color': 'rgba(255, 255, 255, 0.85)',
      '--fl-nav-link-border': 'rgba(255, 255, 255, 0.2)',
      '--fl-nav-link-active-bg': '#ffffff',
      '--fl-nav-link-active-color': '#333333',
      '--fl-nav-link-active-border': '#ffffff',
    },
  },
  [THEMES.HARD_COURT]: {
    name: 'Awesome Aussie',
    description: 'Electric blue & neon lime',
    colors: {
      '--fl-theme-primary': '#0086D1',
      '--fl-theme-primary-dark': '#005A8F',
      '--fl-theme-primary-darker': '#003A5C',
      '--fl-theme-primary-light': '#26A4E5',
      '--fl-theme-primary-lighter': '#6BC5FF',
      '--fl-theme-primary-lightest': '#E3F4FF',
      '--fl-theme-secondary': '#D4FF3F',
      '--fl-theme-secondary-dark': '#A5CC2F',
      '--fl-theme-secondary-light': '#E5FF73',
      '--fl-theme-secondary-lightest': '#F7FFE5',
      '--fl-theme-tertiary': '#D4FF3F',
      '--fl-theme-tertiary-dark': '#A5CC2F',
      '--fl-theme-tertiary-light': '#E5FF73',
      '--fl-theme-tertiary-lightest': '#F7FFE5',
      '--fl-gradient-blue-mid': '#0E7CC1',
      '--fl-gradient-blue-mid-light': '#2398DD',
      '--fl-gradient-blue-mid-alpha': 'rgba(14, 124, 193, 0.12)',
      '--fl-theme-surface': '#F4FAFF',
      '--fl-theme-surface-dim': '#E0ECF7',
      '--fl-theme-surface-bright': '#FFFFFF',
      '--fl-theme-outline': '#BFD5EB',
      '--fl-theme-outline-variant': '#D5E5F5',
      '--fl-button-neutral-bg': '#f8f9fa',
      '--fl-button-neutral-bg-hover': '#e9ecef',
      '--fl-button-neutral-bg-active': '#dee2e6',
      '--fl-button-neutral-border': '#dee2e6',
      '--fl-button-neutral-border-hover': '#adb5bd',
      '--fl-button-neutral-text': '#212529',
      '--fl-button-neutral-shadow': 'rgba(0, 0, 0, 0.08)',
      '--fl-button-neutral-shadow-hover': 'rgba(0, 0, 0, 0.12)',
      '--fl-shadow-tertiary-light': 'rgba(212, 255, 63, 0.15)',
      '--fl-shadow-tertiary-medium': 'rgba(212, 255, 63, 0.25)',
      '--fl-shadow-tertiary-heavy': 'rgba(212, 255, 63, 0.35)',
      '--fl-shadow-blue-lighter': 'rgba(0, 134, 209, 0.08)',
      '--fl-shadow-blue-light': 'rgba(0, 134, 209, 0.15)',
      '--fl-shadow-blue-medium': 'rgba(0, 134, 209, 0.2)',
      '--fl-shadow-blue-strong': 'rgba(0, 134, 209, 0.25)',
      '--fl-shadow-blue-heavy': 'rgba(0, 134, 209, 0.3)',
      '--fl-shadow-modal-backdrop': 'rgba(0, 0, 0, 0.6)',
      '--fl-shadow-modal-elevated': 'rgba(0, 0, 0, 0.3)',
      '--fl-shadow-white-translucent': 'rgba(255, 255, 255, 0.2)',
      '--fl-shadow-white-semi': 'rgba(255, 255, 255, 0.3)',
      '--fl-shadow-white-outline': 'rgba(255, 255, 255, 0.8)',
      '--fl-focus-outline-color': '#0086D1',
      '--fl-gradient-primary':
        'linear-gradient(135deg, #0086D1 0%, #005A8F 100%)',
      '--fl-gradient-hero':
        'linear-gradient(135deg, #0086D1 0%, #0E7CC1 55%, #D4FF3F 100%)',
      '--fl-gradient-subtle':
        'linear-gradient(135deg, #E3F4FF 0%, #F7FFE5 100%)',
      '--fl-gradient-horizontal':
        'linear-gradient(90deg, #0086D1 0%, #0E7CC1 50%, #D4FF3F 100%)',
      '--fl-theme-on-primary': '#ffffff',
      '--fl-theme-on-secondary': '#1a1a1a',
      '--fl-theme-on-tertiary': '#1a1a1a',
      '--fl-text-quaternary': '#9ca3af',
      '--fl-link-color': '#005A8F',
      '--fl-link-hover': '#003A5C',
      '--fl-color-success': '#27ae60',
      '--fl-color-error': '#e74c3c',
      '--fl-color-white': '#ffffff',
      '--fl-color-disabled': '#7f8c8d',
      '--fl-notification-badge': '#FF3B30',
      '--fl-status-bg-tint-start': 'rgba(0, 134, 209, 0.06)',
      '--fl-status-bg-tint-end': 'rgba(0, 90, 143, 0.04)',
      '--fl-status-divider': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-bg': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-fill-start': '#16a34a',
      '--fl-status-progress-fill-end': '#22c55e',
      '--fl-status-notice-text': '#92400e',
      '--fl-analytics-gender-male': '#0088FE',
      '--fl-analytics-gender-female': '#FF69B4',
      '--fl-analytics-gender-neutral': '#77c',
      '--fl-analytics-node-fill': '#0088FE',
      '--fl-analytics-node-text': '#333',
      '--fl-nav-link-bg': 'rgba(255, 255, 255, 0.15)',
      '--fl-nav-link-color': 'rgba(255, 255, 255, 0.85)',
      '--fl-nav-link-border': 'rgba(255, 255, 255, 0.2)',
      '--fl-nav-link-active-bg': '#ffffff',
      '--fl-nav-link-active-color': '#333333',
      '--fl-nav-link-active-border': '#ffffff',
    },
  },
  [THEMES.LAUNCH]: {
    name: 'Serve Sync Launch Theme',
    description: 'Original lime & blue',
    colors: {
      '--fl-theme-primary': '#d4e94c',
      '--fl-theme-primary-dark': '#a6c235',
      '--fl-theme-primary-darker': '#63741f',
      '--fl-theme-primary-light': '#e2f57a',
      '--fl-theme-primary-lighter': '#ebf9a6',
      '--fl-theme-primary-lightest': '#f6fbd4',
      '--fl-theme-secondary': '#2563eb',
      '--fl-theme-secondary-dark': '#1e40af',
      '--fl-theme-secondary-light': '#60a5fa',
      '--fl-theme-secondary-lightest': '#eff6ff',
      '--fl-theme-tertiary': '#1d4ed8',
      '--fl-theme-tertiary-dark': '#1e3a8a',
      '--fl-theme-tertiary-light': '#3b82f6',
      '--fl-theme-tertiary-lightest': '#bfdbfe',
      '--fl-gradient-blue-mid': '#5aa7e0',
      '--fl-gradient-blue-mid-light': '#74baf0',
      '--fl-gradient-blue-mid-alpha': 'rgba(90, 167, 224, 0.12)',
      '--fl-theme-surface': '#f8fafc',
      '--fl-theme-surface-dim': '#e2e8f0',
      '--fl-theme-surface-bright': '#f8fafc',
      '--fl-theme-outline': '#94a3b8',
      '--fl-theme-outline-variant': '#cbd5e1',
      '--fl-button-neutral-bg': '#f8f9fa',
      '--fl-button-neutral-bg-hover': '#e9ecef',
      '--fl-button-neutral-bg-active': '#dee2e6',
      '--fl-button-neutral-border': '#dee2e6',
      '--fl-button-neutral-border-hover': '#adb5bd',
      '--fl-button-neutral-text': '#212529',
      '--fl-button-neutral-shadow': 'rgba(0, 0, 0, 0.08)',
      '--fl-button-neutral-shadow-hover': 'rgba(0, 0, 0, 0.12)',
      '--fl-shadow-tertiary-light': 'rgba(29, 78, 216, 0.25)',
      '--fl-shadow-tertiary-medium': 'rgba(29, 78, 216, 0.35)',
      '--fl-shadow-tertiary-heavy': 'rgba(29, 78, 216, 0.45)',
      '--fl-shadow-blue-lighter': 'rgba(26, 86, 182, 0.15)',
      '--fl-shadow-blue-light': 'rgba(26, 86, 182, 0.25)',
      '--fl-shadow-blue-medium': 'rgba(26, 86, 182, 0.3)',
      '--fl-shadow-blue-strong': 'rgba(26, 86, 182, 0.35)',
      '--fl-shadow-blue-heavy': 'rgba(26, 86, 182, 0.45)',
      '--fl-shadow-modal-backdrop': 'rgba(0, 0, 0, 0.6)',
      '--fl-shadow-modal-elevated': 'rgba(0, 0, 0, 0.3)',
      '--fl-shadow-white-translucent': 'rgba(255, 255, 255, 0.2)',
      '--fl-shadow-white-semi': 'rgba(255, 255, 255, 0.3)',
      '--fl-shadow-white-outline': 'rgba(255, 255, 255, 0.8)',
      '--fl-focus-outline-color': '#2563eb',
      '--fl-gradient-primary':
        'linear-gradient(135deg, #d4e94c 0%, #a6c235 100%)',
      '--fl-gradient-hero':
        'linear-gradient(135deg, #d4e94c 0%, #5aa7e0 55%, #1d4ed8 100%)',
      '--fl-gradient-subtle':
        'linear-gradient(135deg, #f6fbd4 0%, #eff6ff 100%)',
      '--fl-gradient-horizontal':
        'linear-gradient(90deg, #d4e94c 0%, #5aa7e0 50%, #1d4ed8 100%)',
      '--fl-theme-on-primary': '#fff',
      '--fl-theme-on-secondary': '#fff',
      '--fl-theme-on-tertiary': '#fff',
      '--fl-text-quaternary': '#9ca3af',
      '--fl-link-color': '#1e40af',
      '--fl-link-hover': '#1e3a8a',
      '--fl-color-success': '#27ae60',
      '--fl-color-error': '#e74c3c',
      '--fl-color-white': '#ffffff',
      '--fl-color-disabled': '#7f8c8d',
      '--fl-notification-badge': '#FF3B30',
      '--fl-status-bg-tint-start': 'rgba(212, 233, 76, 0.06)',
      '--fl-status-bg-tint-end': 'rgba(166, 194, 53, 0.04)',
      '--fl-status-divider': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-bg': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-fill-start': '#16a34a',
      '--fl-status-progress-fill-end': '#22c55e',
      '--fl-status-notice-text': '#92400e',
      '--fl-analytics-gender-male': '#0088FE',
      '--fl-analytics-gender-female': '#FF69B4',
      '--fl-analytics-gender-neutral': '#77c',
      '--fl-analytics-node-fill': '#0088FE',
      '--fl-analytics-node-text': '#333',
      '--fl-nav-link-bg': 'rgba(255, 255, 255, 0.15)',
      '--fl-nav-link-color': 'rgba(255, 255, 255, 0.85)',
      '--fl-nav-link-border': 'rgba(255, 255, 255, 0.2)',
      '--fl-nav-link-active-bg': '#ffffff',
      '--fl-nav-link-active-color': '#333333',
      '--fl-nav-link-active-border': '#ffffff',
    },
  },
  [THEMES.USUALLY_UNITED]: {
    name: 'Usually United',
    description: 'NYC night sessions & neon',
    colors: {
      '--fl-theme-primary': '#071A52',
      '--fl-theme-primary-dark': '#040F32',
      '--fl-theme-primary-darker': '#02081F',
      '--fl-theme-primary-light': '#12357A',
      '--fl-theme-primary-lighter': '#2F4EA3',
      '--fl-theme-primary-lightest': '#E4E9F7',
      '--fl-theme-secondary': '#FFC700',
      '--fl-theme-secondary-dark': '#D19E00',
      '--fl-theme-secondary-light': '#FFD84D',
      '--fl-theme-secondary-lightest': '#FFF7D6',
      '--fl-theme-tertiary': '#E10600',
      '--fl-theme-tertiary-dark': '#A10400',
      '--fl-theme-tertiary-light': '#FF4A3D',
      '--fl-theme-tertiary-lightest': '#FFE2DE',
      '--fl-gradient-blue-mid': '#12357A',
      '--fl-gradient-blue-mid-light': '#2F4EA3',
      '--fl-gradient-blue-mid-alpha': 'rgba(18, 53, 122, 0.12)',
      '--fl-theme-surface': '#F5F7FB',
      '--fl-theme-surface-dim': '#E1E5F0',
      '--fl-theme-surface-bright': '#FFFFFF',
      '--fl-theme-outline': '#C0C7DD',
      '--fl-theme-outline-variant': '#D6DCEF',
      '--fl-button-neutral-bg': '#f8f9fa',
      '--fl-button-neutral-bg-hover': '#e9ecef',
      '--fl-button-neutral-bg-active': '#dee2e6',
      '--fl-button-neutral-border': '#dee2e6',
      '--fl-button-neutral-border-hover': '#adb5bd',
      '--fl-button-neutral-text': '#212529',
      '--fl-button-neutral-shadow': 'rgba(0, 0, 0, 0.08)',
      '--fl-button-neutral-shadow-hover': 'rgba(0, 0, 0, 0.12)',
      '--fl-shadow-tertiary-light': 'rgba(225, 6, 0, 0.18)',
      '--fl-shadow-tertiary-medium': 'rgba(225, 6, 0, 0.28)',
      '--fl-shadow-tertiary-heavy': 'rgba(225, 6, 0, 0.38)',
      '--fl-shadow-blue-lighter': 'rgba(7, 26, 82, 0.08)',
      '--fl-shadow-blue-light': 'rgba(7, 26, 82, 0.15)',
      '--fl-shadow-blue-medium': 'rgba(7, 26, 82, 0.2)',
      '--fl-shadow-blue-strong': 'rgba(7, 26, 82, 0.25)',
      '--fl-shadow-blue-heavy': 'rgba(7, 26, 82, 0.3)',
      '--fl-shadow-modal-backdrop': 'rgba(0, 0, 0, 0.6)',
      '--fl-shadow-modal-elevated': 'rgba(0, 0, 0, 0.3)',
      '--fl-shadow-white-translucent': 'rgba(255, 255, 255, 0.2)',
      '--fl-shadow-white-semi': 'rgba(255, 255, 255, 0.3)',
      '--fl-shadow-white-outline': 'rgba(255, 255, 255, 0.8)',
      '--fl-focus-outline-color': '#071A52',
      '--fl-gradient-primary':
        'linear-gradient(135deg, #071A52 0%, #040F32 100%)',
      '--fl-gradient-hero':
        'linear-gradient(135deg, #071A52 0%, #12357A 55%, #FFC700 100%)',
      '--fl-gradient-subtle':
        'linear-gradient(135deg, #E4E9F7 0%, #FFF7D6 100%)',
      '--fl-gradient-horizontal':
        'linear-gradient(90deg, #071A52 0%, #12357A 50%, #FFC700 100%)',
      '--fl-theme-on-primary': '#ffffff',
      '--fl-theme-on-secondary': '#1a1a1a',
      '--fl-theme-on-tertiary': '#ffffff',
      '--fl-text-quaternary': '#9ca3af',
      '--fl-link-color': '#12357A',
      '--fl-link-hover': '#040F32',
      '--fl-color-success': '#27ae60',
      '--fl-color-error': '#e74c3c',
      '--fl-color-white': '#ffffff',
      '--fl-color-disabled': '#7f8c8d',
      '--fl-notification-badge': '#FF3B30',
      '--fl-status-bg-tint-start': 'rgba(7, 26, 82, 0.06)',
      '--fl-status-bg-tint-end': 'rgba(4, 15, 50, 0.04)',
      '--fl-status-divider': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-bg': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-fill-start': '#16a34a',
      '--fl-status-progress-fill-end': '#22c55e',
      '--fl-status-notice-text': '#92400e',
      '--fl-analytics-gender-male': '#0088FE',
      '--fl-analytics-gender-female': '#FF69B4',
      '--fl-analytics-gender-neutral': '#77c',
      '--fl-analytics-node-fill': '#0088FE',
      '--fl-analytics-node-text': '#333',
      '--fl-nav-link-bg': 'rgba(255, 255, 255, 0.15)',
      '--fl-nav-link-color': 'rgba(255, 255, 255, 0.85)',
      '--fl-nav-link-border': 'rgba(255, 255, 255, 0.2)',
      '--fl-nav-link-active-bg': '#ffffff',
      '--fl-nav-link-active-color': '#333333',
      '--fl-nav-link-active-border': '#ffffff',
    },
  },
  [THEMES.FREAKING_FRENCH]: {
    name: 'Freaking French',
    description: 'True clay, deep green & cream',
    colors: {
      '--fl-theme-primary': '#B35425',
      '--fl-theme-primary-dark': '#8A3F1B',
      '--fl-theme-primary-darker': '#5C2A12',
      '--fl-theme-primary-light': '#C96A36',
      '--fl-theme-primary-lighter': '#E09363',
      '--fl-theme-primary-lightest': '#F8E5D6',
      '--fl-theme-secondary': '#275135',
      '--fl-theme-secondary-dark': '#1A3723',
      '--fl-theme-secondary-light': '#356D47',
      '--fl-theme-secondary-lightest': '#E0EEE5',
      '--fl-theme-tertiary': '#C06A33',
      '--fl-theme-tertiary-dark': '#8E4C24',
      '--fl-theme-tertiary-light': '#D88753',
      '--fl-theme-tertiary-lightest': '#F6E4D4',
      '--fl-gradient-blue-mid': '#A45630',
      '--fl-gradient-blue-mid-light': '#C07245',
      '--fl-gradient-blue-mid-alpha': 'rgba(164, 86, 48, 0.12)',
      '--fl-theme-surface': '#FFF8EF',
      '--fl-theme-surface-dim': '#F0E1CF',
      '--fl-theme-surface-bright': '#FFFBF6',
      '--fl-theme-outline': '#E1CDBA',
      '--fl-theme-outline-variant': '#EAD8C7',
      '--fl-button-neutral-bg': '#f8f9fa',
      '--fl-button-neutral-bg-hover': '#e9ecef',
      '--fl-button-neutral-bg-active': '#dee2e6',
      '--fl-button-neutral-border': '#dee2e6',
      '--fl-button-neutral-border-hover': '#adb5bd',
      '--fl-button-neutral-text': '#212529',
      '--fl-button-neutral-shadow': 'rgba(0, 0, 0, 0.08)',
      '--fl-button-neutral-shadow-hover': 'rgba(0, 0, 0, 0.12)',
      '--fl-shadow-tertiary-light': 'rgba(39, 81, 53, 0.15)',
      '--fl-shadow-tertiary-medium': 'rgba(39, 81, 53, 0.25)',
      '--fl-shadow-tertiary-heavy': 'rgba(39, 81, 53, 0.35)',
      '--fl-shadow-blue-lighter': 'rgba(163, 86, 48, 0.08)',
      '--fl-shadow-blue-light': 'rgba(163, 86, 48, 0.15)',
      '--fl-shadow-blue-medium': 'rgba(163, 86, 48, 0.2)',
      '--fl-shadow-blue-strong': 'rgba(163, 86, 48, 0.25)',
      '--fl-shadow-blue-heavy': 'rgba(163, 86, 48, 0.3)',
      '--fl-shadow-modal-backdrop': 'rgba(0, 0, 0, 0.6)',
      '--fl-shadow-modal-elevated': 'rgba(0, 0, 0, 0.3)',
      '--fl-shadow-white-translucent': 'rgba(255, 255, 255, 0.2)',
      '--fl-shadow-white-semi': 'rgba(255, 255, 255, 0.3)',
      '--fl-shadow-white-outline': 'rgba(255, 255, 255, 0.8)',
      '--fl-focus-outline-color': '#B35425',
      '--fl-gradient-primary':
        'linear-gradient(135deg, #B35425 0%, #8A3F1B 100%)',
      '--fl-gradient-hero':
        'linear-gradient(135deg, #B35425 0%, #A45630 55%, #275135 100%)',
      '--fl-gradient-subtle':
        'linear-gradient(135deg, #F8E5D6 0%, #E0EEE5 100%)',
      '--fl-gradient-horizontal':
        'linear-gradient(90deg, #B35425 0%, #A45630 50%, #275135 100%)',
      '--fl-theme-on-primary': '#ffffff',
      '--fl-theme-on-secondary': '#ffffff',
      '--fl-theme-on-tertiary': '#ffffff',
      '--fl-text-quaternary': '#9ca3af',
      '--fl-link-color': '#8A3F1B',
      '--fl-link-hover': '#5C2A12',
      '--fl-color-success': '#27ae60',
      '--fl-color-error': '#e74c3c',
      '--fl-color-white': '#ffffff',
      '--fl-color-disabled': '#7f8c8d',
      '--fl-notification-badge': '#FF3B30',
      '--fl-status-bg-tint-start': 'rgba(179, 84, 37, 0.06)',
      '--fl-status-bg-tint-end': 'rgba(138, 63, 27, 0.04)',
      '--fl-status-divider': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-bg': 'rgba(0, 0, 0, 0.08)',
      '--fl-status-progress-fill-start': '#16a34a',
      '--fl-status-progress-fill-end': '#22c55e',
      '--fl-status-notice-text': '#92400e',
      '--fl-analytics-gender-male': '#0088FE',
      '--fl-analytics-gender-female': '#FF69B4',
      '--fl-analytics-gender-neutral': '#77c',
      '--fl-analytics-node-fill': '#0088FE',
      '--fl-analytics-node-text': '#333',
      '--fl-nav-link-bg': 'rgba(255, 255, 255, 0.15)',
      '--fl-nav-link-color': 'rgba(255, 255, 255, 0.85)',
      '--fl-nav-link-border': 'rgba(255, 255, 255, 0.2)',
      '--fl-nav-link-active-bg': '#ffffff',
      '--fl-nav-link-active-color': '#333333',
      '--fl-nav-link-active-border': '#ffffff',
    },
  },
}

/**
 * Apply a theme by setting CSS variables on the document root
 * @param {string} themeKey - The theme key from THEMES constant
 */
export const applyTheme = (themeKey) => {
  const theme = THEME_CONFIGS[themeKey]
  if (!theme) return

  // Apply all CSS variables to document root
  Object.entries(theme.colors).forEach(([property, value]) => {
    document.documentElement.style.setProperty(property, value)
  })
}

/**
 * Get the saved theme from localStorage or return default
 * @returns {string} The theme key
 */
export const getSavedTheme = () => {
  return localStorage.getItem('app-theme') || THEMES.HARD_COURT
}

/**
 * Save theme preference to localStorage
 * @param {string} themeKey - The theme key to save
 */
export const saveTheme = (themeKey) => {
  localStorage.setItem('app-theme', themeKey)
}

/**
 * Initialize theme on app load
 */
export const initializeTheme = () => {
  const savedTheme = getSavedTheme()
  applyTheme(savedTheme)
}
